import { useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import arrowWest from "../../../assets/images/west_arrow_black.svg"
import arrowEast from "../../../assets/images/east_arrow_black.svg"
import formatQuote from "../../../assets/images/format_quote.svg"

const Testimonial = () => {

    const scrollRef = useRef(null)
    const [prevDisabled, setPrevDisabled] = useState(false);
    const [nextDisabled, setNextDisabled] = useState(false);

    const testimonialData = useMemo(() => [
        {
            id: "1",
            message: <span>Working with Sentellent has transformed how we serve our community at the <a href="https://cmn.edu/" target="_blank">College of the Muscogee Nation</a>. Their team quickly grasped our unique challenges and developed a tailored Campus Insights AI solution that exceeded our expectations. I appreciate their commitment to bringing innovative technology to our institution at a fair price point.</span>,
            name: "Dr. Monte Randall",
            role: "President, College of the Muscogee Nation",
            color: "#2B3733"
        },
        // {
        //     id: "2",
        //     message: "Campus Insights at the College of the Muscogee Nation shows how educational institutions can leverage AI for both mission and operations. I've seen how this technology creates a blueprint for transforming standard websites into powerful tools for engagement and recruitment, while honoring each institution's unique values.",
        //     name: "Don Harjo Daves-Rougeaux",
        //     role: "Senior Advisor, California Community Colleges",
        //     color: "#2971C8"
        // }
    ], [])

    const checkScrollPosition = () => {
        setTimeout(() => {
            const scrollLeft = scrollRef.current.scrollLeft;
            const scrollWidth = scrollRef.current.scrollWidth;
            const containerWidth = scrollRef.current.offsetWidth;

            setPrevDisabled(scrollLeft === 0);
            setNextDisabled(scrollLeft + containerWidth >= scrollWidth);
        }, 500)
    };

    const handlePrev = () => {
        if (!prevDisabled) {
            scrollRef.current.scrollBy({
                left: window.innerWidth > 540 ? -540 : -window.innerWidth+5,
                behavior: 'smooth',
            });
            checkScrollPosition();
        }
    };

    const handleNext = () => {
        if (!nextDisabled) {
            scrollRef.current.scrollBy({
                left: window.innerWidth > 540 ? 540 : window.innerWidth-5,
                behavior: 'smooth',
            });
            checkScrollPosition();
        }
    };

    useEffect(() => {
        checkScrollPosition()
        window.addEventListener("resize", checkScrollPosition)

        return () => {
            window.removeEventListener("resize", checkScrollPosition)
        }
    }, [])

    return (
        <div className="testimonials">
            <div className="testimonials-title">What Our Users Are Saying</div>
            <div className="testimonials-container">
                <div className="scroll-container" ref={scrollRef} onScroll={checkScrollPosition}>
                    {testimonialData.map(({ id, message, name, role, color }) => (
                        <div key={id} className="testimonial-card" style={{ backgroundColor: color }}>
                            <img src={formatQuote} alt="" className="quote start" />
                            <div className="message">{message}</div>
                            <div>
                                <div className="name">{name}</div>
                                <div className="role">{role}</div>
                            </div>
                            <img src={formatQuote} alt="" className="quote end" />
                        </div>
                    )
                    )}
                </div>
                {/* <div className="arrow-container">
                    <div className={`arrow ${prevDisabled ? "disabled" : ""}`} onClick={handlePrev}>
                        <img src={arrowWest} alt="" />
                    </div>
                    <div className={`arrow ${nextDisabled ? "disabled" : ""}`} onClick={handleNext} >
                        <img src={arrowEast} alt="" />
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Testimonial;